import type { InventoryResource } from '@repo/api-gw-sdk';

import {
  apps,
  sourceAccountId,
  backupPolicies,
  backupRegions,
  backupStorageSize,
  dataClasses,
  environment,
  lastBackup,
  resourceId,
  sourceRegion,
  sourceStorageSize,
  subnets,
  tags,
  vpc,
  resourceName,
  resourceType,
  vaults,
  genericSnapshotsDistinctDateCount,
  dbEngine,
  dateDiscovered,
  resourceGroupName,
  clusterName,
  namespaceName,
  s3BucketBackupType,
  securityAssignmentStatus,
  eonSnapshotsCount,
  id,
  sourceStorageObjectCount,
} from '@/components/queryBuilder/properties';
import type { FilterProperty } from '@/types/advanceFilter';

export const inventoryItemFields = [
  resourceName,
  resourceId,
  id,
  resourceType,
  resourceGroupName,
  dbEngine,
  clusterName,
  namespaceName,
  dataClasses,
  environment,
  apps,
  sourceRegion,
  tags,
  backupPolicies,
  vaults,
  lastBackup,
  backupRegions,
  securityAssignmentStatus,
  s3BucketBackupType,
  sourceStorageObjectCount,
  sourceStorageSize,
  eonSnapshotsCount,
  backupStorageSize,
  genericSnapshotsDistinctDateCount,
  dateDiscovered,

  sourceAccountId,
  vpc,
  subnets,
] as FilterProperty<InventoryResource>[];
